import { Navigate, useLocation } from 'react-router-dom';
import { getCookie } from '../utils/helpers';
import { isTokenRefreshInProgress } from '../services/auth';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import NotFound from '../pages/NotFound';

// For Supervisor, effective role is their "view as" (Patient or Doctor/Nurse); otherwise actual role.
function getEffectiveRole(role, viewAsRole) {
  if (role === 'Supervisor') {
    return viewAsRole === 'Doctor/Nurse' ? 'Doctor/Nurse' : 'Patient';
  }
  return role;
}



export default function PrivateRoute({ children, allowedRoles }) {
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  const [isAuthed, setIsAuthed] = useState(false);
  const userRole = useSelector((state) => state.user.role);
  const viewAsRole = useSelector((state) => state.user.viewAsRole);
  const onBoardingCompleted = useSelector((state) => state.user.on_boarding_completed);
  const onBoardingStep = useSelector((state) => state.user.on_boarding_step);
  const mustChangePassword = useSelector((state) => state.user.must_change_password);
  const effectiveRole = getEffectiveRole(userRole, viewAsRole);


  useEffect(() => {
    const check = () => {
      const hasCookie = Boolean(getCookie('access') || getCookie('refresh'));
      setIsAuthed(hasCookie);
      setIsReady(true);
    };
    check();
    const id = setInterval(check, 1000);
    return () => clearInterval(id);
  }, []);

  if (!isReady) return null;

  if (!isAuthed && !isTokenRefreshInProgress()) {
    return <Navigate to="/signin" replace />;
  }

  const onboardingIncomplete = onBoardingCompleted === false;
  const needsPasswordChange =
    onboardingIncomplete && mustChangePassword === true;
  const isPersonalDetailsStep =
    String(onBoardingStep || '').trim() === 'Personal Details';
  const isBarcodeStep =
    ['bar code', 'barcode'].includes(String(onBoardingStep || '').trim().toLowerCase());
  const needsBarcodeActivation =
    onboardingIncomplete && !needsPasswordChange && isBarcodeStep;
  const needsProfileCompletion =
    onboardingIncomplete && !needsPasswordChange && isPersonalDetailsStep;
  // const needsMedicalInfo =
  //   onBoardingCompleted === false &&
  //   (onBoardingStep === 'Medical Info' || String(onBoardingStep || '').trim() === 'Medical Info');
  const isPersonalInfoPage = location.pathname === '/personal-information';
  const isActivateBarcodePage = location.pathname === '/activate-barcode';
  const isOnboardingChangePasswordPage = location.pathname === '/onboarding/change-password';
  // const isMedicalInfoPage = location.pathname === '/medical-info';

  if (isAuthed && needsPasswordChange && !isOnboardingChangePasswordPage) {
    return <Navigate to="/onboarding/change-password" replace />;
  }
  if (isAuthed && needsBarcodeActivation && !isActivateBarcodePage) {
    return <Navigate to="/activate-barcode" replace />;
  }
  if (isAuthed && needsProfileCompletion && !isPersonalInfoPage) {
    return <Navigate to="/personal-information" replace />;
  }
  // if (isAuthed && needsMedicalInfo && !isMedicalInfoPage) {
  //   return <Navigate to="/medical-info" replace />;
  // }

  const hasAllowedRole = !allowedRoles
    || allowedRoles.includes(effectiveRole)
    || allowedRoles.includes(userRole);

  if (!hasAllowedRole) {
    return <NotFound />;
  }

  return children;
}
